import { isValidPhoneNumber } from "react-phone-number-input";

export const validatePhoneNumber = (value) => {
	const phoneNumber = isValidPhoneNumber(`+${String(value)}`);
	if (!phoneNumber) {
		return false;
	} else if (phoneNumber === "TOO_SHORT" || phoneNumber === "TOO_LONG") {
		return false;
	}
	return phoneNumber;
};
